export const mainNavigation = [
  {
    title: "Solutions",
    path: "/solutions",
    children: [
      {
        title: "Clinical Automation",
        path: "/solutions/clinical-automation",
        children: [
          { title: "Virtual Nursing Observation", path: "/solutions/clinical-automation/virtual-nursing-observation" },
          { title: "Cognitive Screening & Intake", path: "/solutions/clinical-automation/cognitive-screening-intake" },
          { title: "Remote Patient Monitoring", path: "/solutions/clinical-automation/remote-patient-monitoring" },
          { title: "Patient Access Automation", path: "/solutions/clinical-automation/patient-access-automation" },
        ]
      },
      {
        title: "Workforce & Customer Experience",
        path: "/solutions/workforce-customer-experience",
        children: [
          { title: "Workforce Optimization", path: "/solutions/workforce-customer-experience/workforce-optimization" },
          { title: "Customer Experience", path: "/solutions/workforce-customer-experience/customer-experience" },
        ]
      }
    ]
  },
  {
    title: "Platform & Devices",
    path: "/platform-devices",
    children: [
      { title: "AI-Enabled Bedside Devices", path: "/platform-devices/ai-enabled-bedside-devices" },
      { title: "Wearables", path: "/platform-devices/wearables" },
      { title: "EHR Workflow Integrations", path: "/platform-devices/ehr-workflow-integrations" },
    ]
  },
  {
    title: "Resources",
    path: "/resources",
    children: [
      { title: "Case Studies", path: "/resources/case-studies" },
      { title: "White Papers & Research", path: "/resources/white-papers-research" },
      { title: "Webinars & Demos", path: "/resources/webinars-demos" },
      { title: "Blog & News", path: "/resources/blog-news" },
    ]
  },
  {
    title: "About",
    path: "/about",
  },
  {
    title: "Technology",
    path: "/technology",
  },
  {
    title: "How It Works",
    path: "/how-it-works",
  },
  {
    title: "Compliance & Security",
    path: "/compliance-security",
  },
  {
    title: "Contact",
    path: "/contact-request-demo",
  },
];